import { Component, input } from '@angular/core';

import { IsDefinedNotEmptyPipe, IsDefinedPipe } from '@softline/ui-core';
import { KommissionsauftragBewe } from '../../types/kommissionsauftrag';
import { isDefinedNotEmpty } from '@softline/core';

@Component({
  selector: 'soft-store-item',
  imports: [IsDefinedPipe, IsDefinedNotEmptyPipe],
  templateUrl: './store-item.component.html',
  styleUrl: './store-item.component.css',
})
export class StoreItemComponent {
  readonly beweInput = input.required<KommissionsauftragBewe>({ alias: 'bewe' });
  readonly displayQuantity = input(true);
  readonly useScannedQuantity = input(false);
  protected readonly isDefinedNotEmpty = isDefinedNotEmpty;
}
